import React, { useCallback } from 'react';
import { useShellRootContext } from 'src/contexts/ShellRoot';
import { Logger } from 'src/utils/Logger';

export const useGetTenantId = () => {
  const {
    interfaces: { v1 }
  } = useShellRootContext();

  const { tenantHandlerInterface } = v1;

  const getTenantId = useCallback(() => {
    try {
      const tenantId = tenantHandlerInterface.getTenantId();
      Logger.log(`TenantId: ${tenantId}`);
      return tenantId;
    } catch (error) {
      Logger.log('getTenantId returned empty', error.message);
      return '';
    }
  }, [tenantHandlerInterface]);

  return { getTenantId };
};
